<template>
  <div id="app" :class="{ 'h-full': !isIDP }">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.lang.title,
      meta: [{ vmid: 'description', name: 'description', content: this.lang.description }],
    };
  },
  created() {
    this.loadRecaptcha();
    this.getIsoCountryCode();
    this.getSession();
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      const html = document.documentElement;

      if ('IntersectionObserver' in window) {
        const lazyBackgroundObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('lazy-background');
              lazyBackgroundObserver.unobserve(entry.target);
            }
          });
        });

        lazyBackgroundObserver.observe(html);
      } else {
        html.classList.add('lazy-background');
      }
    });
  },
  destroyed() {
    this.$cookies.remove('visitor');
  },
  computed: {
    ...mapState(['lang', 'clientId']),
    isIDP() {
      return this.clientId?.includes('IDP');
    },
  },
  methods: {
    ...mapActions('auth', [
      'loadRecaptcha',
      'getIsoCountryCode',
      'getSession'
    ]),
  },
};
</script>
